module.exports = __webpack_public_path__ + "static_assets/img/rsooicons.2614e56.svg";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/rsooicons.svg
// module id = icmm
// module chunks = 40